<template>
    <SimpleLayout>
        <div class="container-nzidoo my-5" :style="{ paddingBottom: productsBatch.length > 0 ? '100px' : '0' }">
            <LoadingSpinner v-if="loader" />

            <!-- Listings Header -->
            <div v-else>
                <div class="header">
                    <h1 class="mb-0">
                        {{ $t("sentence.announcementsOf") }}
                        <span class="font-weight-bold"> {{ user?.username }} </span>
                        <p class="text-primary h4 mb-0">
                            ({{ sellerProducts.length }} {{ $t("sentence.announcement") }})
                        </p>
                    </h1>
                </div>
                <!-- Listings Grid -->
                <div class="row row-min-size products-grid mx-1 mx-md-0" ref="productsGrid">
                    <div class="col-6 col-md-3 d-flex" v-for="product in sellerProducts" :key="product.id">
                        <div class="product-wrapper w-100 d-flex flex-column p-2 bg-white rounded">
                            <ProductSingle class="product-item flex-grow-1" :showDescription="false" :product="product" />
                            <button class="btn mt-2 w-100" :class="isInBatch(product.id) ? 'btn-danger' : 'btn-primary'"
                                @click="toggleProductBatch(product)">
                                {{ isInBatch(product.id) ? $t("action.remove") : $t("action.add") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Fixed Bottom Bar -->
            <div v-if="productsBatch.length > 1" class="fixed-bottom-actions">
                <div class="container-nzidoo">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="total-price">
                            <span class="price">
                                {{ totalPrice.toFixed(2) | currency(" DA", 0, { symbolOnLeft: false }) }}
                            </span>
                            <span class="count">({{ productsBatch.length }} {{ $t("sentence.items") }})</span>
                        </div>
                        <button class="btn btn-primary btn-see-batch" @click="goToBatchView">
                            {{ $t("action.seeBatch") }}
                        </button>
                    </div>
                </div>
            </div>

            <notifications class="custom-notifications mt-2" group="success" position="top center" />
            <notifications class="custom-notifications mt-2" group="error" position="top center" />
        </div>
    </SimpleLayout>
</template>

<script>
import ProductSingle from "@/components/templates/ProductSingle.vue";
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';
import SimpleLayout from "@/layouts/SimpleLayout.vue";
import helper from "@/services/helper";
import config from "@/config";

export default {
    name: "BatchCreate",
    components: {
        ProductSingle,
        LoadingSpinner,
        SimpleLayout,
    },
    props: {

    },

    watch: {
    },
    data() {
        return {
            user: null,
            sellerProducts: [],
            moreProducts: [],
            config,
            loader: false,
            loadingFavorite: false,
        };
    },

    mounted() {
        this.$store.dispatch('batch/clearBatch');
        this.getUserProfile();

    },
    computed: {
        authUser: {
            get() {
                return this.$store.state.user;
            },
        },
        productsBatch() {
            return this.$store.state.batch.productsBatch||[];
        },
        filteredMoreProducts() {
            const sellerIds=this.sellerProducts.map(p => p.id);
            return this.moreProducts.filter(p => !sellerIds.includes(p.id));
        },
        totalPrice() {
            return this.productsBatch.reduce((sum, product) => {
                return sum+(parseFloat(product.price)||0);
            }, 0);
        }
    },
    methods: {
        isInBatch(productId) {
            return (this.$store.state.batch.productsBatch||[]).some(p => p.id===productId);
        },

        toggleProductBatch(product) {
            // Use Vuex batch module to toggle product
            this.$store.dispatch('batch/toggleProduct', product);
        },

        goToBatchView() {
            // Ensure there are products in the batch before navigating
            const batchLength = (this.$store.state.batch.productsBatch || []).length;
            if (batchLength <= 1) {
                // Notify user that batch is empty
                if (this.$notify) {
                    this.$notify({ group: 'error', title: this.$t('sentence.selectMoreThanOne') || '', text: this.$t('sentence.selectMoreThanOne') });
                } else {
                    // Fallback: console warning
                    console.warn('Batch is empty. Cannot navigate to batch view.');
                }
                return;
            }

            // Navigate to batch view page (data is in Vuex)
            this.$router.push({
                name: 'BatchView',
                params: {
                    seller_id: this.$route.params.id
                }
            });
        },

        getUserProfile() {
            if (!this.$route.params.id) return;

            const id=this.$route.params.id;
            this.loader=true;

            this.$axios.get(`user/profile/${id}`)
                .then(({ data }) => {
                    if (data?.data) {
                        this.user=data.data;
                        this.sellerProducts=(data.data.products||[]).filter(p=>p.sales_type==='fixed')
                        this.getMoreProducts(10);
                    } else {
                        this.user=null;
                        this.sellerProducts=[];
                    }
                })
                .catch(err => {
                    console.error("Error fetching user profile:", err);
                    this.user=null;
                    this.sellerProducts=[];
                })
                .finally(() => {
                    this.loader=false;
                });
        },
        getMoreProducts(number) {
            this.$axios({
                url: "product/list/random/"+number+"/"+0,
                method: "GET",
            })
                .then((response) => {
                    this.moreProducts=response.data;
                })
                .catch((err) => {
                    console.error("Error fetching random products:", err);
                    this.moreProducts=[];
                });
        },

        formatDate: helper.formatDate,
    },
};
</script>

<style scoped>
/* Header Styles */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-dark);
}

.see-more {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: var(--color-dark);
    text-decoration: none;
}

.product-wrapper {
    display: flex;
    flex-direction: column;
}

.product-item {
    flex: 1 1 auto;
    width: 100%;
    padding: 0.25rem;
}

.total-price {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.total-price .label {
    font-size: 14px;
    color: var(--color-6);
}

.total-price .price {
    font-size: 20px;
    font-weight: 700;
    color: var(--color-primary);
}

.total-price .count {
    font-size: 12px;
    color: var(--color-9);
}

.btn-see-batch {
    padding: 12px 32px;
    font-weight: 600;
    white-space: nowrap;
}

/* Responsive Design */
@media (min-width: 576px) {
    .product-item {
        width: 100%;
    }
}

@media (max-width: 576px) {
    .total-price .price {
        font-size: 18px;
    }

    .btn-see-batch {
        padding: 10px 20px;
        font-size: 14px;
    }
}
</style>